import { Grid, Typography, Box, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { SimCardDownload } from '@mui/icons-material';
import { getInvoiceSendingPdfByUrl } from 'src/shared/services/invoiceService';
import { useState } from 'react';
import { ContentSection } from 'src/shared/components/organisms/contentSection';
import { InvoiceEvent } from '../models/invoiceEvent';

type InvoiceEventsDetailsProps = {
  events: InvoiceEvent[];
};

const InvoiceEventsDetails = (props: InvoiceEventsDetailsProps) => {
  const { events } = props;
  const { t } = useTranslation(['invoice']);
  const [PDFLoading, setPDFLoading] = useState(false);

  const downloadInvoiceSendingPdf = async (link: string, date: Date) => {
    setPDFLoading(true);
    try {
      await getInvoiceSendingPdfByUrl(link)
        .then(
          (response) =>
            new Blob([response.data], {
              type: 'application/pdf',
            }),
        )
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `faktura_${date}.pdf`;
          a.click();
          a.remove();
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
            setPDFLoading(false);
          }, 100);
        });
    } catch (err) {
      setPDFLoading(false);
    }
  };

  return (
    <ContentSection header={t('invoice:events')}>
      {events.map((event, index: number) => {
        return (
          // CreatedAt ska vara unikt men vill inte ändra förrän vi har flera events att testa med
          // eslint-disable-next-line react/no-array-index-key
          <Grid key={index} item xs={12} display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
            <Box>
              <Typography sx={{ fontWeight: 600, fontSize: 16 }} variant='h6'>
                {event.name}
              </Typography>
              <Typography sx={{ fontWeight: 400, fontSize: 16, lineHeight: 1 }} color='GrayText' variant='subtitle1'>
                {dayjs(event.createdAt).format('YYYY-MM-DD')}
              </Typography>
            </Box>
            {event.url && (
              <Box>
                <IconButton color='primary' onClick={() => downloadInvoiceSendingPdf(event.url, event.createdAt)} disabled={PDFLoading} size='large'>
                  <SimCardDownload />
                </IconButton>
              </Box>
            )}
          </Grid>
        );
      })}
    </ContentSection>
  );
};

export default InvoiceEventsDetails;
